export default __webpack_public_path__ + "static/media/testimonial3.8572e78e.png";